module.exports = __webpack_public_path__ + "static/dashboard_bn1M@2x-c33b3a92d6fb3fd4a8f9a3ba0509dd11.jpg";